import Config from '../config';
import { defineStore } from 'pinia';

export const useKbStore = defineStore('kbStore', 
{
    getters:
    {
        home():string
        {
            return Config.SUPPORT_URL;
        },
        environmentTimeRemaining(): string
        {
            return new URL("/features/persistent-nonpersistent-environment.html#environment-time-remaining", this.home).href;
        },
        clockOutOfSync(): string
        {
            return new URL("/troubleshooting/cant-login.html#pclaptop-system-clock-time-date-skew", this.home).href;
        }
    }
});
